export default __webpack_public_path__ + "static/media/ugur7.7a63abea.jpg";